
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa3955ba52ec3784cc3f106e9fea4ed57en from './en.yaml'
            i18n.addResourceBundle('en', 'a3955ba52ec3784cc3f106e9fea4ed57', flattenObject(nsa3955ba52ec3784cc3f106e9fea4ed57en), true, true);
        
        export default 'a3955ba52ec3784cc3f106e9fea4ed57';
    